<div>
  <div class="grid">
    <div class="col-12">
      <fieldset>
        <legend>{{ appSettings.translate[appSettings.selectedLang]['penalty_and_dnf'] }}</legend>
        <div>
          <div class="item-field">
            <div class="label">
              <span>{{ appSettings.translate[appSettings.selectedLang]['penalty'] }}</span>
            </div>
            <div class="input">
              <input id="input" type="number" size="30" pInputText [(ngModel)]="penalty" />
            </div>
          </div>
          <div class="item-field">
            <div class="label">
              <span>{{ appSettings.translate[appSettings.selectedLang]['comment'] }}</span>
            </div>
            <div class="input">
              <input
                id="input"
                type="text"
                size="30"
                maxlength="200"
                pInputText
                [(ngModel)]="competitor.penaltyComment"
                [placeholder]="appSettings.translate[appSettings.selectedLang]['comment']"
              />
            </div>
          </div>
          <div class="item-field">
            <div class="label">
              <span>{{ appSettings.translate[appSettings.selectedLang]['dnf'] }}</span>
            </div>
            <div class="input">
              <p-dropdown [options]="dnfs" [(ngModel)]="competitor.DNF" (onChange)="changeDnf($event)">
                <ng-template let-item pTemplate="selectedItem">
                  {{ appSettings.translate[appSettings.selectedLang]['descent_' + item.label] }}
                </ng-template>
                <ng-template let-item pTemplate="item">
                  {{ appSettings.translate[appSettings.selectedLang]['descent_' + item.label] }}
                </ng-template>
              </p-dropdown>
            </div>
          </div>
          <div class="item-field">
            <div class="label">
              <span>{{ appSettings.translate[appSettings.selectedLang]['dnf_reason'] }}</span>
            </div>
            <div class="input">
              <input
                id="input"
                [disabled]="competitor.DNF === 0"
                type="text"
                size="30"
                maxlength="200"
                pInputText
                [(ngModel)]="competitor.DNFreason"
                [placeholder]="appSettings.translate[appSettings.selectedLang]['dnf_reason']"
              />
            </div>
          </div>
          <div class="item-field">
            <p-button
              icon="pi pi-save"
              [style]="{ 'background-color': '#254C74' }"
              (onClick)="saveDnfPenalty()"
              [label]="appSettings.translate[appSettings.selectedLang]['ok']"
            ></p-button>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="marks col-12">
      <p-table [value]="marks" [style]="{ 'font-size': '12px', 'margin-bottom': '10px' }" [scrollable]="true">
        <ng-template pTemplate="header" let-i="rowIndex">
          <tr>
            <th>{{ appSettings.translate[appSettings.selectedLang]['marshal_num'] }}</th>
            <th>{{ appSettings.translate[appSettings.selectedLang]['dateTimeMark'] }}</th>
            <th>{{ appSettings.translate[appSettings.selectedLang]['time_from_previous_mark'] }}</th>
            <th style="flex: 0 0 3rem">
              <span class="pi pi-pencil"></span>
            </th>
            <th style="flex: 0 0 3rem">
              <span class="pi pi-times"></span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-mark let-i="rowIndex">
          <tr>
            <td class="marshal-cell flex-nowrap" (click)="mark.expanded = !mark.expanded">
              <div class="flex">
                {{ mark.type === 'mark' ? mark.marshal : '' }}
                {{ mark.type !== 'mark' ? appSettings.translate[appSettings.selectedLang][mark.type] : ''
                }}{{ mark.type === 'finish/mark' ? mark.marshal : '' }}
              </div>
            </td>
            <td (click)="mark.expanded = !mark.expanded" [style.text-decoration]="mark.delDate ? 'line-through' : 'none'" [style.font-style]="mark.editUser ? 'italic' : 'normal'">
              <ng-container *ngIf="!mark.markDate || mark.markDate.getTime() == 0; else markDate">-</ng-container>
              <ng-template #markDate>{{ mark.markDate | date : 'dd.MM.yyyy HH:mm:ss' : timeOffset }}</ng-template>
            </td>
            <td [style.text-decoration]="mark.delDate ? 'line-through' : 'none'" [style.font-style]="mark.editUser ? 'italic' : 'normal'">{{ mark.timeSincePreviousMark }}</td>
            <td class="p-0" style="flex: 0 0 3rem; justify-content: center">
              <p-button
                icon="pi pi-pencil"
                [style]="{ 'background-color': '#254C74' }"
                [disabled]="mark.delTime"
                (onClick)="showEditMarkDialog(mark)"
              ></p-button>
            </td>
            <td class="p-0" style="flex: 0 0 3rem; justify-content: center">
              <p-button
                *ngIf="!mark.delTime && !mark.delDate"
                [disabled]="mark.type != 'mark' && mark.type != 'finish/mark'"
                icon="pi pi-times"
                [style]="{ 'background-color': '#254C74' }"
                (onClick)="deleteMark(mark)"
              ></p-button>
              <p-button
                *ngIf="mark.delTime"
                icon="pi pi-replay"
                [style]="{ 'background-color': '#254C74' }"
                (onClick)="undoMark(mark)"
              ></p-button>
            </td>
          </tr>
          <ng-container *ngIf="mark.expanded">
            <tr>
              <td colspan="2">{{ appSettings.translate[appSettings.selectedLang]['created'] }}</td>
              <td colspan="3">{{ mark.createUser }}</td>
            </tr>
            <tr>
              <td colspan="2">{{ appSettings.translate[appSettings.selectedLang]['edited'] }}</td>
              <td colspan="3">{{ mark.editUser }}</td>
            </tr>
            <tr>
              <td colspan="2">{{ appSettings.translate[appSettings.selectedLang]['deleted'] }}</td>
              <td colspan="3">
                {{ mark.delUser
                }}<ng-container *ngIf="mark.delDate">, {{ mark.delDate | date : 'dd.MM.yyyy HH:mm:ss' : timeOffset }}</ng-container>
              </td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>

      <div class="button-wrapper">
        <!-- <p-button icon="pi pi-plus" [style]="{ 'background-color': '#254C74' }" (onClick)="newMark()"></p-button> -->
      </div>
    </div>
    <div class="footer col-12">
      <div class="grid">
        <div class="col-3">
          <button class="col-12" type="button" pButton label="Закрыть" (click)="closeDialog(false)"></button>
        </div>
        <div class="col-7">
          <button class="col-12" type="button" pButton label="Закрыть и обновить" (click)="closeDialog(true)"></button>
        </div>
        <div class="col-2">
          <p-button icon="pi pi-plus" [style]="{ 'background-color': '#254C74' }" (onClick)="newMark()"></p-button>
        </div>
      </div>
    </div>
  </div>
</div>
